
import {Canvas} from '@react-three/fiber'

//import Objects
import SphereObject from './sphere/Sphere'
// style
import {BackgroundStyle } from './BackgroundStyle'

export default function Background() {
  return(
    <Canvas id="Background" style={BackgroundStyle}>
      <SphereObject position={[0,0.6,1.8]} />
    </Canvas>
  )
}